<template>
  <div class="guide">
    <div class="guide_top">
      <img src="../../image/find.jpg" alt=" ">
    </div>
    <div class="guide_bot">
      <!-- <div class="guide_logo">
                <img class='logo' src="../../image/logo-m.png" alt="logo" />
                <span class="title">{{$t('login.title')}}</span>
      </div>-->
      <v-header></v-header>
      <span class="title">{{$t('login.title')}}</span>
      <form>
        <div>
          <img src="../../image/people.png" alt=" ">
          <input
            type="text"
            required="required"
            class="input_text"
            maxlength="32"
            @change="loginphone"
            v-model="input_text"
            :placeholder="$t('login.enteraccount')"
          >
          <span
            class="clear_input"
            @click="clear_input"
            v-bind:class="{'clear_inputb':isB,'clear_inputn':isN}"
          >X</span>
        </div>
        <p class="denger" v-show="flag1">{{$t('login.accountnot')}}</p>
        <div>
          <img src="../../image/password.png" alt=" ">
          <input
            type="password"
            required="required"
            class="password_text"
            maxlength="16"
            v-model="password_text"
            :placeholder="$t('login.accountpassword')"
          >
          <span class="clear_password" @click="clear_password">X</span>
        </div>
        <p class="identifying_code" v-show="flag">
          <input
            v-show="flag"
            type="text"
            name
            id
            value
            v-model="code"
            :placeholder="$t('login.entercode')"
          >
          <img v-show="flag" :src="img" class="image" @click="change" ref="banner">
        </p>
        <div>
          <p @click="login" id="sub">{{$t('login.signIn')}}</p>
          <button type="button" id="but">{{$t('login.ApplyQrCode')}}</button>
        </div>
      </form>
    </div>
    <div class="reg">
      <router-link to="/register">{{$t('loginswiper.goregister')}}</router-link>|
      <router-link to="/forgetpassword">{{$t('login.forgetPsd')}}</router-link>
    </div>
    <div class="footer" v-if="false">
      <p class="three">{{$t('login.ThirdPartyLogin')}}</p>
      <ul>
        <li>
          <a
            :href="'https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=101523560&redirect_uri=http://dognesstest.dognessnetwork.com/authentication/social/callback/qq&state=dogness?id=' + this.$route.query.id"
          >
            <img src="@/image/qq.png">
          </a>
        </li>
        <li>
          <a
            href="https://api.weibo.com/oauth2/authorize?client_id=1981994093&redirect_uri=http://dognesstest.dognessnetwork.com/authentication/social/callback/weibo&response_type=code"
          >
            <img src="@/image/sina.png">
          </a>
        </li>
        <li>
          <a @click="facebooklogin(codeId)">
            <img src="@/image/facebook.png">
          </a>
        </li>
        <li>
          <a @click="twitch(codeId)">
            <img src="@/image/twitter.png">
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import footer from "../../components/footernav";
import header from "../../components/header";
//import IScroll from 'iscroll/build/iscroll-probe'
import { systemInit, email, userLogin } from "../../api/index.js";
import { getimg } from "../../api/index.js";
import { bindDevice } from "../../deviceApi/index.js";
// import { facebooklogin } from "../../api/facebooklogin.js";
import store from "../../store/store.js";
import Qs from "qs";
import axios from "axios";
export default {
  name: "guide",
  data() {
    return {
      username: "",
      password: "",
      code: "",
      count: 0,
      checked: false,
      flag: false,
      flag1: false,
      img: "",
      num: 1,
      loginsuccess: false,
      loginshowflag: true,
      input_text: "",
      password_text: "",
      isB: true,
      isN: false,
      x_auth_token: "",
      codeId: ""
    };
  },
  created() {
    sessionStorage.removeItem("login");
    sessionStorage.removeItem("token");

    this.codeId = this.$route.query.id;
    systemInit()
      .then(res => {
        console.log(res);
        let data = res.headers["x-auth-token"];
        if (data != undefined) {
          this.$store.commit("set_token", data); //根据store中set_token方法将token保存至localStorage/sessionStorage中，data["Authentication-Token"]，获取token的value值
          console.log(data);
        }
      })
      .catch(error => {
        console.log(error);
      });

    if (sessionStorage.getItem("imgcode")) {
      this.flag = true;
      getimg()
        .then(res => {
          this.img = "data:image/jpeg;base64," + res.data.data;
        })
        .catch(error => {
          console.log(error);
        });
    }
    if (localStorage) {
      this.username = localStorage.getItem("username");
      this.password = localStorage.getItem("password");
    }
  },
  components: {
    foot: footer,
    "v-header": header
  },
  methods: {
    // facebooklogin(id) {
    //     //fb登录
    //     facebooklogin(id);
    // },
    // twitch(id) {
    //     //推特登录
    //     var log = console.log;
    //     hello.init({
    //         twitter: "UCGoimkpcQy3JbdzJSYWRPiua"
    //         // facebook: "460654774345388"
    //     });
    //     var twitter = hello("twitter");
    //     twitter.logout().then(function(r) {
    //         console.log(r);
    //     }, log);
    //     twitter.login().then(function(r) {
    //         console.log(r, r.oauth_token, r.oauth_token_secret); // 得到access_token**********************8
    //         window.location.href =
    //             "http://apius.dognessnetwork.com:8877/authentication/social/callback/twitter" +
    //             "?token=" +
    //             r.authResponse.oauth_token +
    //             "&token_secret=" +
    //             r.authResponse.oauth_token_secret +
    //             "&id=" +
    //             id;
    //     });
    // },
    loginphone() {
      var params = Qs.stringify({
        account: this.input_text
      });
      email(params)
        .then(res => {
          if (res.data.data == false) {
            this.flag1 = true;
          } else {
            this.flag1 = false;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //login()登陆事件	Qs.stringify()将对象 序列化成URL的形式，以&进行拼接	axios()从node.js发出http请求、拦截or转换or取消 请求和响应、自动转换JSON数据
    login() {
      var params = Qs.stringify({
        username: this.input_text,
        password: this.password_text,
        imageCode: this.code
      });
      userLogin(params)
        .then(res => {
          console.log("res", res);
          if (res.data.header.status == 1000) {
            sessionStorage.removeItem("imgcode");
            this.loginsuccess = true;
            //若有设备deviceCode则添加设备
            this.x_auth_token = res.data.data.x_auth_token;
            let params = Qs.stringify({
              code: this.$route.query.id
            });
            sessionStorage.setItem("login", "1");
            localStorage.setItem("token", res.data.data.x_auth_token);
            this.$store.commit("set_token", this.x_auth_token);
            bindDevice(params).then(res => {
              console.log(res.data);
              if (res.data.header.status == 1000) {
                this.$router.push("/myAccount");
              } else if (res.data.header.status == "4102") {
                alert(this.$t("prompt.bindfailure"));
              } else if (res.data.header.status != "1000") {
                alert(this.$t("prompt.contactkf"));
              }
            });
          } else {
            this.$message({
              // message: res.data.header.message,
              message: this.$t("prompt.loginswiperError"),
              center: true,
              type: "error"
            });
            if (res.data.data.hasImgCode) {
              sessionStorage.setItem("imgcode", res.data.data.hasImgCode);
            }
            if (res.data.header.status == 3001) {
              this.flag = true;
              getimg()
                .then(res => {
                  this.img = "data:image/jpeg;base64," + res.data.data;
                })
                .catch(error => {
                  console.log(error);
                });
            }
          }
        })
        .catch(error => {
          console.log(error);
        });

      if (this.checked == true) {
        localStorage.setItem("username", this.username);
        localStorage.setItem("password", this.password);
      }
    },
    //  change verifying code
    change() {
      getimg()
        .then(res => {
          this.img = "data:image/jpeg;base64," + res.data.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    clear_input() {
      //clear input value
      this.input_text = "";
    },
    clear_password() {
      //clear password value
      this.password_text = "";
    }
  }
};
</script>
<style scoped>
.title {
  font-size: 0.8rem;
  color: #828282;
  text-align: center;
  display: block;
  padding: 5px 0;
}
.guide {
  width: 100%;
}
.guide_top {
  width: 100%;
}
.guide_top img {
  width: 100%;
}
.guide_bot {
  width: 100%;
}
.guide_logo {
  width: 100%;
  text-align: center;
  margin: 0 auto;
  margin-top: 10px;
}
.guide_logo img {
  vertical-align: middle;
}
.guide_logo span {
  font-size: 0.75rem;
  display: block;
  color: #828282;
}
.qrTag {
  width: 1.2rem;
}
.logo {
  width: 8rem;
}
.guide_bot form div {
  width: 80%;
  margin: 0 auto;
  height: 3.4rem;
  line-height: 3.4rem;
  position: relative;
  text-align: center;
  margin-bottom: 0.1rem;
}
.guide_bot form div input {
  width: 100%;
  height: 2.4rem;
  line-height: 100%;
  box-sizing: border-box;
  border: 1px solid #bfbfbf;
  border-radius: 5px;
  padding-left: 1.8rem;
  padding-right: 2.2rem;
}
.guide_bot form div input:focus {
  outline: none;
  border: 1px solid #38aaff;
}
.guide_bot form div img {
  width: 1.2rem;
  position: absolute;
  left: 2%;
  top: 0.8rem;
  vertical-align: middle;
}
.guide_bot form div button,
#sub {
  width: 42%;
  height: 2.2rem;
  line-height: 2.2rem;
  border-radius: 5px;
  display: block;
  float: left;
  border: 0px;
  background-color: #0f589b;
  color: #ffffff;
  font-size: 0.7rem;
  margin-top: 0.5rem;
}
.guide_bot form div button#but {
  float: right;
  background-color: #eeeeee;
  color: #949393;
}
.reg {
  width: 80%;
  height: 1.6rem;
  line-height: 1.6rem;
  font-size: 0.6rem;
  /*position: absolute;*/
  bottom: 0.5rem;
  left: 10%;
  margin-left: 10%;
  text-align: center;
  /*margin-top: 0.5rem;*/
}
.reg a {
  margin: 0 10px;
  color: #000000;
}
/*清除表单内容*/
.clear_input,
.clear_password {
  position: absolute;
  right: 0.5rem;
  top: 1.2rem;
  font-size: 0.8rem;
  color: #ffffff;
  display: none;
  width: 1.2rem;
  height: 1.2rem;
  line-height: 1.2rem;
  border-radius: 50%;
  border: 1px solid #cccccc;
  background: #cccccc;
  text-align: center;
}
.input_text:valid + .clear_input,
.password_text:valid + .clear_password {
  display: block;
}
.clear_inputb {
  opacity: 1;
}
.clear_inputn {
  opacity: 0;
}
/*验证码*/
.identifying_code {
  width: 80%;
  height: 3.4rem;
  margin: 0 auto;
  margin-bottom: 0.8rem;
}
.identifying_code input {
  width: 50%;
  height: 3.4rem;
  line-height: 100%;
  float: left;
  border-radius: 5px;
  border: 1px solid #bfbfbf;
  box-sizing: border-box;
  padding: 0 10px;
}
.identifying_code input:focus {
  outline: none;
  border: 1px solid #38aaff;
}
.identifying_code .image {
  float: right;
}
.denger {
  width: 80%;
  margin: 0 auto;
  font-size: 0.625rem;
  color: red;
  margin-top: 5px;
}
/*第三方登陆*/
.three {
  text-align: center;
  color: #b4b4b4;
  position: relative;
  font-size: 0.8rem;
  margin-top: 2rem;
}
.three:after {
  content: "";
  border-bottom: solid 1px #b4b4b4;
  width: 35%;
  display: block;
  position: absolute;
  top: 50%;
  right: 0;
}
.three:before {
  content: "";
  border-bottom: solid 1px #b4b4b4;
  width: 35%;
  display: block;
  position: absolute;
  top: 50%;
  left: 0;
}
.footer ul {
  display: flex;
  margin-top: 1rem;
}
.footer ul li {
  flex: 1;
  position: relative;
}
.footer ul li img {
  width: 2rem;
  height: 2rem;
  position: absolute;
  left: 50%;
  transform: translate(-50%);
}
.footer ul li p {
  font-size: 0.8rem;
  text-align: center;
  margin-top: 2.5rem;
  color: black;
}
.ver {
  position: relative;
}
.image {
  position: absolute;
  right: 0%;
  top: 70%;
  transform: translate(0%, -70%);
}
</style> 


// WEBPACK FOOTER //
// src/m_page/finder/guide.vue